import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const ClaimsHistory = lazyLoad(
    () => import('./index'),
    module => module.ClaimsHistory,
    { fallback: <LoadingSpinner /> },
);
